import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11 15H5a2.25 2.25 0 0 1-2.25-2.25V5.72a.75.75 0 0 1 1.5 0v7.07a.74.74 0 0 0 .75.75h6a.74.74 0 0 0 .75-.75V5.72a.75.75 0 0 1 1.5 0v7.07A2.25 2.25 0 0 1 11 15Zm3-12h-3a2.26 2.26 0 0 0-2.24-2h-1.5A2.26 2.26 0 0 0 5 3H2a.75.75 0 0 0 0 1.5h12A.75.75 0 0 0 14 3Zm-3.75 8V7.22a.75.75 0 0 0-1.5 0V11a.75.75 0 0 0 1.5 0Zm-3 0V7.22a.75.75 0 0 0-1.5 0V11a.75.75 0 0 0 1.5 0Z';
const draw24px =
  'M16,20.82H8a2.75,2.75,0,0,1-2.75-2.75V8.65a.75.75,0,0,1,1.5,0v9.42A1.25,1.25,0,0,0,8,19.32h8a1.25,1.25,0,0,0,1.25-1.25V8.65a.75.75,0,1,1,1.5,0v9.42A2.75,2.75,0,0,1,16,20.82ZM20.73,6a.74.74,0,0,1-.75.75H4a.75.75,0,0,1,0-1.5H8.25A2.75,2.75,0,0,1,11,2.54h2a2.76,2.76,0,0,1,2.75,2.72H20A.75.75,0,0,1,20.73,6Zm-6.48-.75A1.26,1.26,0,0,0,13,4H11A1.25,1.25,0,0,0,9.75,5.26Zm.5,10.44V10.64a.75.75,0,0,0-1.5,0V15.7a.75.75,0,0,0,1.5,0Zm-4,0V10.64a.75.75,0,0,0-1.5,0V15.7a.75.75,0,0,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TrashCanIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'trashCan'),
) as IconWithRender;

TrashCanIcon.displayName = 'TrashCanIcon';
TrashCanIcon.propTypes = Icon.propTypes;
TrashCanIcon.renderIcon = (props) => <TrashCanIcon {...props} />;
export default TrashCanIcon;
